module.exports = __webpack_public_path__ + "static/img/logo.29ba551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = cH+4
// module chunks = 1